import {FC} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/de'
import '@formatjs/intl-relativetimeformat/locale-data/es'
import '@formatjs/intl-relativetimeformat/locale-data/fr'
import '@formatjs/intl-relativetimeformat/locale-data/ja'
import '@formatjs/intl-relativetimeformat/locale-data/zh'

import deMessages from './messages/de.json'
import enMessages from './messages/en.json'
import esMessages from './messages/es.json'
import frMessages from './messages/fr.json'
import jaMessages from './messages/ja.json'
import zhMessages from './messages/zh.json'
import hiMessages from './messages/hi.json'
import bnMessages from './messages/bn.json'
import itmessages from './messages/it.json'
import koMessages from './messages/ko.json'
import ptMessages from './messages/pt.json'
import ruMessages from './messages/ru.json'
import {WithChildren} from '../helpers'

const allMessages = {
  de: deMessages,
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  ja: jaMessages,
  zh: zhMessages,
  hi: hiMessages,
  bn: bnMessages,
  it: itmessages,
  ko: koMessages,
  pt: ptMessages,
  ru: ruMessages,
}

const ignoreDefaulMessageError = (error: any) => {
  if ( process.env.REACT_APP_DISABLE_TRANSLATION_ERROR === 'true' &&
    typeof error.message === "string" && 
    error.message.includes("[@formatjs/intl Error MISSING_TRANSLATION]")) {

    return;
  }
  else {
    console.error(error)
  }
};

const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages} onError={ignoreDefaulMessageError}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
